import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Profile } from "./Profile";

export function ProfileMain() {
  const { customer } = ZuAuthStore();

  const [searchParams] = useSearchParams();
  const atSign = searchParams.get("atsign");

  useEffect(() => {}, []);

  return (
    <>
      {atSign ? (
        <>
          <Profile atSign={atSign} />
        </>
      ) : (
        <>{customer && <Profile atSign={customer.customer.atSign} />}</>
      )}
    </>
  );
}
